module.exports = __webpack_public_path__ + "img/otherCard.8a098222.png";